import CopilotMessagesAPI from 'dashboard/api/captain/copilotMessages';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'CopilotMessages',
  API: CopilotMessagesAPI,
  getters: {
    getMessagesByThreadId: state => copilotThreadId => {
      return state.records
        .filter(record => record.copilot_thread?.id === Number(copilotThreadId))
        .sort((a, b) => a.id - b.id);
    },
  },
  actions: mutationTypes => ({
    upsert({ commit }, data) {
      commit(mutationTypes.UPSERT, data);
    },
    // Streaming snapshot for an in-flight reply. The empty assistant record already exists
    // (via copilot.message.created); each event carries the full accumulated content, and the
    // final one (`done: true`) reconciles it to the content the backend persisted.
    appendDelta({ commit }, data) {
      commit('APPEND_DELTA', data);
    },
  }),
  mutations: {
    APPEND_DELTA(state, { id, content, done }) {
      const record = state.records.find(item => item.id === Number(id));
      if (!record) return;

      // Snapshots ride unordered broadcast jobs: keep the longest text seen so
      // a late shorter frame can't rewind the reply; `done` is authoritative.
      const existing = record.message?.content || '';
      const next = content ?? '';
      const nextContent =
        done || next.length >= existing.length ? next : existing;
      record.message = {
        ...record.message,
        content: nextContent,
        streaming: !done,
      };
    },
  },
});
